export default "__VITE_ASSET__CfnabRHV__"